module.exports = __webpack_public_path__ + "static/ruthBader-3f109819f192948ea877558869bc30c1.jpg";